import { render, staticRenderFns } from "./BlockType117.vue?vue&type=template&id=55d0f646&scoped=true"
import script from "./BlockType117.vue?vue&type=script&lang=ts"
export * from "./BlockType117.vue?vue&type=script&lang=ts"
import style0 from "./BlockType117.vue?vue&type=style&index=0&id=55d0f646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d0f646",
  null
  
)

export default component.exports